































































































import { defineComponent } from '@nuxtjs/composition-api';
import { IBlokSingleImage } from '~/components/storyblok/SingleImage.vue';
import { PropType } from 'vue';
import { SfCarousel, SfCarouselItem } from '~/components/StorefrontUi';

interface Slide {
  _uid: string;
  banner: IBlokSingleImage[];
  // eslint-disable-next-line no-undef
  link?: SbLink;
}

interface Blok {
  _uid: string;
  title: string;
  leftBanner: Slide[];
  rightTopBanner: Slide[];
  rightBottomBanner: Slide[];
}

export default defineComponent({
  name: 'PromoArticles',
  components: {
    SfCarousel,
    SfCarouselItem,
  },
  props: {
    blok: {
      type: Object as PropType<Blok>,
      required: true,
    },
  },
  setup({ blok }: { blok: Blok }) {
    const { leftBanner, rightTopBanner, rightBottomBanner } = blok;
    const leftBannerData = (leftBanner && leftBanner.length > 0 && leftBanner[0].banner.length > 0) ? {
      banner: leftBanner[0].banner[0],
      link: leftBanner[0].link,
    } : null;
    const rightTopBannerData = (rightTopBanner && rightTopBanner.length > 0 && rightTopBanner[0].banner.length > 0) ? {
      banner: rightTopBanner[0].banner[0],
      link: rightTopBanner[0].link,
    } : null;
    const rightBottomBannerData = (rightBottomBanner && rightBottomBanner.length > 0 && rightBottomBanner[0].banner.length > 0) ? {
      banner: rightBottomBanner[0].banner[0],
      link: rightBottomBanner[0].link,
    } : null;

    return {
      leftBannerData,
      rightTopBannerData,
      rightBottomBannerData,
    };
  },
});
